<script>
import QueryIdentityField from './QueryIdentity.field.vue';

export default {
    extends: QueryIdentityField,
    props: {
        fieldName: {
            type: String,
            default: 's_perc_identity',
        },
    },
};
</script>
